module.exports = __webpack_public_path__ + "static/media/Médico Ocaña_edited.2803f17e.jpg";